export function createExternalShipmentWithLabelUseCase(externalShipmentWithLabelData, externalShipmentWithLabelRepository) {
    const external_shipment_with_label = new externalShipmentWithLabelRepository.model(externalShipmentWithLabelData);
  
    const is_valid = external_shipment_with_label.isValid();

    if (is_valid != true) {
      throw new Error(is_valid);
    }
  
    return externalShipmentWithLabelRepository.save_with_label(external_shipment_with_label);
}